import { render, staticRenderFns } from "./KnLocalAlert.vue?vue&type=template&id=5af14b29&"
import script from "./KnLocalAlert.vue?vue&type=script&lang=js&"
export * from "./KnLocalAlert.vue?vue&type=script&lang=js&"
import style0 from "./KnLocalAlert.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports